import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SubscriptionsService from "../../api/subscriptions";


export const getSubscriptions = createAsyncThunk(
  "subscriptions/get",
  async (args, thunkAPI) => {
    try {
      const response = await SubscriptionsService.getSubscriptions(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSubscriptionDetail = createAsyncThunk(
  "subscriptionDetail/get",
  async (args, thunkAPI) => {
    try {
      const response = await SubscriptionsService.getSubscriptionDetail(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateSubscription = createAsyncThunk(
  "subscriptionDetail/patch",
  async ({ subscriptionId, args }, thunkAPI) => {
    try {
      const response = await SubscriptionsService.updateSubscription(subscriptionId, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const setSubscriptionExpiry = createAsyncThunk(
  "subscriptionExpiry/post",
  async ({ subscriptionId, args }, thunkAPI) => {
    try {
      const response = await SubscriptionsService.setSubscriptionExpiry(subscriptionId, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  "subscription/cancel",
  async ({ subscriptionId, args }, thunkAPI) => {
    try {
      const response = await SubscriptionsService.cancelSubscription(subscriptionId, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const restartSubscription = createAsyncThunk(
  "subscription/restart",
  async ({ subscriptionId, args }, thunkAPI) => {
    try {
      const response = await SubscriptionsService.restartSubscription(subscriptionId, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  done: false,
  results: [],
  count: 0,
  next: null,
  previous: null,
  selectedSubscription: null,
  error: null,
  loading: false,
  loadingDetail: false,
  loadingUpdate: false,
  loadingCancel: false,
  shouldUpdate: false,
  shouldUpdateList: false,
};

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    setShouldUpdateList: (state, action) => {
      state.shouldUpdateList = true;
    }, 
  },
  extraReducers: {
    [getSubscriptions.pending]: (state, action) => {
      state.loading = true;
    },
    [getSubscriptions.fulfilled]: (state, action) => {
      Object.assign(state, action.payload);
      state.loading = false;
      state.shouldUpdateList = false
      state.done = true
    },
    [getSubscriptions.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja áskriftir";
      state.done = true
    },
    [getSubscriptionDetail.pending]: (state, action) => {
      state.loadingDetail = true;
    },
    [getSubscriptionDetail.fulfilled]: (state, action) => {
      state.selectedSubscription = action.payload;
      state.loadingDetail = false;
      state.shouldUpdate = false
    },
    [getSubscriptionDetail.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja áskrift";
      state.loadingDetail = false;
    },
    [updateSubscription.pending]: (state, action) => {
      state.loadingUpdate = true;
    },
    [updateSubscription.fulfilled]: (state, action) => {
      state.selectedSubscription = Object.assign(state.selectedSubscription, {
        description: action.payload.description,
        reference: action.payload.reference,
        discount: action.payload.discount,
        amount: action.payload.amount,
        active_until: action.payload.active_until,
      });
      state.loadingUpdate = false;
    },
    [updateSubscription.rejected]: (state, action) => {
      state.error = "Ekki tókst að uppfæra áskrift";
      state.loadingUpdate = false;
    },
    [cancelSubscription.pending]: (state, action) => {
      state.loadingCancel = true;
    },
    [cancelSubscription.fulfilled]: (state, action) => {
      // state.selectedSubscription = Object.assign(state.selectedSubscription, {
      //   description: action.payload.description, 
      //   reference: action.payload.reference
      // });
      state.loadingCancel = false;
      state.shouldUpdate = true
    },
    [cancelSubscription.rejected]: (state, action) => {
      state.error = "Ekki tókst að uppfæra áskrift";
      state.loadingCancel = false;
    },
    [restartSubscription.pending]: (state, action) => {
      state.loadingCancel = true;
    },
    [restartSubscription.fulfilled]: (state, action) => {
      state.loadingCancel = false;
      state.shouldUpdate = true
    },
    [restartSubscription.rejected]: (state, action) => {
      state.error = "Ekki tókst að uppfæra áskrift";
      state.loadingCancel = false;
    },
    [setSubscriptionExpiry.pending]: (state, action) => {
      state.loadingUpdate = true;
    },
    [setSubscriptionExpiry.fulfilled]: (state, action) => {
      state.loadingUpdate = false;
    },
    [setSubscriptionExpiry.rejected]: (state, action) => {
      state.loadingUpdate = false;
    },

  },
});

const { reducer } = subscriptionsSlice;
export default reducer;
export const { setShouldUpdateList } = subscriptionsSlice.actions